import moment from "moment";
import i18n from "i18n";
const formatDuration = (durationInMs) => {
  const duration = moment.duration(durationInMs);
  return [
    { unit: "days", count: Math.floor(duration.asDays()) },
    { unit: "hours", count: duration.hours() },
    { unit: "minutes", count: duration.minutes() },
    { unit: "seconds", count: duration.seconds() }
  ].filter(({ count }) => count > 0).map(({ unit, count }) => i18n.t(`duration.${unit}`, { ns: "common", count })).join(" ");
};
export default formatDuration;
